import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    _createVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.5 5.5l-3.447 5.29a1.641 1.641 0 00-.043 1.723L7.5 18.5H18.86c.906 0 1.64-.735 1.64-1.641V7.14c0-.906-.734-1.641-1.64-1.641H7.5zM10 8.5l7 7M10 15.5l6.93-7"
    })
  ]))
}